<template>
  <LegalDocPage title="隐私政策" :body-html="html" />
</template>

<script>
import LegalDocPage from '../components/LegalDocPage.vue'

const html = `
<h2>一、引言</h2>
<p>Go Trust（以下简称“本平台”）重视用户隐私保护。本《隐私政策》说明我们如何收集、使用、存储、共享与保护您的个人信息，以及您享有的权利。您使用本平台即表示理解并同意本政策。</p>

<h2>二、我们收集的信息</h2>
<p>为实现留学考学辅导相关服务，我们可能收集：</p>
<ul>
  <li><strong>账号信息</strong>：手机号、验证码、昵称、头像等；</li>
  <li><strong>资料信息</strong>：个人档案中您主动填写的学历、意向院校、语言成绩等；</li>
  <li><strong>交易信息</strong>：订单、支付相关必要信息、优惠券领取与使用记录；</li>
  <li><strong>沟通信息</strong>：您在即时通讯中发送的文本、图片、文件等（用于师生沟通与客服处理）；</li>
  <li><strong>设备与日志信息</strong>：设备型号、系统版本、网络状态、操作日志、崩溃信息等，用于保障安全与改进体验；</li>
  <li><strong>权限相关信息</strong>：在您授权后访问相册、相机、麦克风、通知等（用于发图、语音、消息提醒等功能）。</li>
</ul>
<p>我们遵循最小必要原则，不会超范围收集与业务无关的信息。</p>

<h2>三、我们如何使用信息</h2>
<ul>
  <li>创建与维护账号、完成登录验证；</li>
  <li>提供课程浏览、下单支付、订单履约、售后与评价；</li>
  <li>提供师生沟通、消息通知；</li>
  <li>开展优惠券、邀请等活动并核销权益；</li>
  <li>保障平台安全、防范欺诈与滥用；</li>
  <li>改进产品体验、进行必要的统计分析（尽可能脱敏）；</li>
  <li>遵守法律法规要求，响应监管与司法机关合法请求。</li>
</ul>

<h2>四、信息共享与披露</h2>
<p>我们不会出售您的个人信息。仅在以下情形共享或披露：</p>
<ul>
  <li>获得您的明确同意或授权；</li>
  <li>为完成支付、短信、对象存储、即时通讯等，向必要的服务商提供履约所需信息，并要求其承担保密义务；</li>
  <li>根据法律法规、诉讼、仲裁或行政主管机关的强制性要求；</li>
  <li>在合并、收购等情形下，依法告知并要求承继方继续受本政策约束。</li>
</ul>

<h2>五、Cookie 与同类技术</h2>
<p>在 Web / H5 场景中，我们可能使用本地存储、Cookie 等技术记住登录态或偏好设置，用于保持会话与提升体验。您可通过浏览器设置进行管理，但这可能影响部分功能。</p>

<h2>六、信息存储与保护</h2>
<ul>
  <li>您的信息存储于中华人民共和国境内；如需跨境，将依法履行评估与告知义务。</li>
  <li>我们采取合理的安全措施保护数据，但请理解互联网环境并非绝对安全。</li>
  <li>我们仅在实现目的所必需的期限内保留信息，超期将删除或匿名化处理（法律另有规定除外）。</li>
</ul>

<h2>七、您的权利</h2>
<p>在适用法律范围内，您有权：</p>
<ul>
  <li>查询、更正您的部分个人信息；</li>
  <li>撤回授权（可能影响相关功能使用）；</li>
  <li>注销账号（可通过客服申请，我们将依法处理）；</li>
  <li>对处理活动提出疑问或投诉。</li>
</ul>

<h2>八、未成年人保护</h2>
<p>本平台主要面向具有完全民事行为能力的用户。若您为未成年人，请在监护人陪同下阅读本政策，并在监护人同意后使用服务。我们不会主动收集未成年人的个人信息用于与服务无关的目的。</p>

<h2>九、政策更新</h2>
<p>我们可能适时更新本政策，并在本页面公布。重大变更时，我们将通过显著方式提示。若更新后您继续使用本平台，即视为接受更新后的政策。</p>

<h2>十、联系我们</h2>
<p>如对本隐私政策或个人信息处理有疑问、投诉或建议，请通过 App 内反馈/客服入口与我们联系。我们将在合理期限内予以答复。</p>
`

export default {
  name: 'LegalPrivacyPage',
  components: { LegalDocPage },
  data() {
    return { html }
  },
}
</script>
